import React from "react";

const SocialLinks = ({ instagramUrl, linkedinUrl, youtubeUrl }) => {
  const items = [
    {
      label: "Instagram",
      href: instagramUrl,
      icon: (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none">
          <path
            d="M7 3H17C19.2 3 21 4.8 21 7V17C21 19.2 19.2 21 17 21H7C4.8 21 3 19.2 3 17V7C3 4.8 4.8 3 7 3Z"
            stroke="var(--brand)"
            strokeWidth="2"
          />
          <path
            d="M12 16C14.2 16 16 14.2 16 12C16 9.8 14.2 8 12 8C9.8 8 8 9.8 8 12C8 14.2 9.8 16 12 16Z"
            stroke="var(--brand-accent)"
            strokeWidth="2"
          />
          <path
            d="M17.5 6.5H17.51"
            stroke="var(--brand-accent)"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      )
    },
    {
      label: "LinkedIn",
      href: linkedinUrl,
      icon: (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none">
          <path
            d="M4 4H8V20H4V4Z"
            stroke="var(--brand)"
            strokeWidth="2"
          />
          <path
            d="M10 9H14V20H10V9Z"
            stroke="var(--brand)"
            strokeWidth="2"
          />
          <path
            d="M14 12C14 10.3 15.3 9 17 9C18.7 9 20 10.3 20 12V20H16V12"
            stroke="var(--brand-accent)"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M6 8H6.01"
            stroke="var(--brand-accent)"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      )
    },
    {
      label: "YouTube",
      href: youtubeUrl,
      icon: (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none">
          <path
            d="M10 15L15 12L10 9V15Z"
            fill="var(--brand-accent)"
          />
          <path
            d="M21 12C21 12 21 8.5 20.6 7.3C20.4 6.6 19.9 6.1 19.2 5.9C18 5.5 12 5.5 12 5.5C12 5.5 6 5.5 4.8 5.9C4.1 6.1 3.6 6.6 3.4 7.3C3 8.5 3 12 3 12C3 12 3 15.5 3.4 16.7C3.6 17.4 4.1 17.9 4.8 18.1C6 18.5 12 18.5 12 18.5C12 18.5 18 18.5 19.2 18.1C19.9 17.9 20.4 17.4 20.6 16.7C21 15.5 21 12 21 12Z"
            stroke="var(--brand)"
            strokeWidth="2"
          />
        </svg>
      )
    }
  ];

  return (
    <div className="grid gap-3">
      {items.map((it) => (
        <a
          key={it.label}
          href={it.href}
          target="_blank"
          rel="noreferrer"
          className="group flex items-center justify-between rounded-xl border border-[color:var(--border)] bg-white px-4 py-3 transition hover:-translate-y-0.5 hover:shadow-md"
        >
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--surface)] border border-[color:var(--border)]">
              {it.icon}
            </div>
            <div className="text-sm font-semibold text-[color:var(--navy)]">
              {it.label}
            </div>
          </div>

          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[color:var(--brand)]/10 transition group-hover:bg-[color:var(--brand)]/15">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12H19M19 12L13 6M19 12L13 18"
                stroke="var(--brand)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
